import React, { Component } from "react";
import { withRoutes } from "../../../shared/containers/containerRoutes";
import styles from "./routeControlPoints.module.scss";
import { withControlPoints } from "../../../shared/containers/containerControlPoints";
import { withRouteControlPoint } from "../../../shared/containers/containerRouteControlPoints";

class RouteControlPointTools extends Component {
  constructor(props) {
    super(props);

    this.state = {
      route: null,
      controlPoint: null,
      inRoute: false,
      isLast: false,
    };
  }

  buttonClickHandle() {
    const { onCreateRouteControlPoint, onDeleteRouteControlPoint, onUnselectControlPoint } = this.props;
    const { controlPoint, route, inRoute } = this.state;

    const options = { route, controlPoint, number: route.controlPoints.length + 1 };

    if (inRoute) {
      onDeleteRouteControlPoint(options);
    } else {
      onCreateRouteControlPoint(options);
    }

    this.setState({ controlPoint: null });
    onUnselectControlPoint();
  }

  componentDidMount() {
    const { controlPoints, selectedControlPointId, routes, selectedRouteId } = this.props;

    if (selectedControlPointId === null) {
      this.setState({ controlPoint: null });
    }

    if (selectedControlPointId !== null && selectedRouteId !== null) {
      const controlPoint = controlPoints.filter((x) => {
        return x.id === selectedControlPointId;
      })[0];

      const route = routes.filter((x) => {
        return x.id === selectedRouteId;
      })[0];

      const inRoute = route.controlPoints.some((controlPoint) => {
        return controlPoint.id === selectedControlPointId;
      });

      const isLast = route.controlPoints.length > 0 && route.controlPoints[route.controlPoints.length - 1].id === selectedControlPointId;

      this.setState({
        route,
        controlPoint,
        inRoute,
        isLast,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { controlPoints, selectedControlPointId, routes, selectedRouteId } = this.props;

    if (selectedControlPointId !== prevProps.selectedControlPointId || selectedRouteId !== prevProps.selectedRouteId) {
      if (selectedControlPointId === null) {
        this.setState({ controlPoint: null });
      }

      if (selectedControlPointId !== null && selectedRouteId !== null) {
        const controlPoint = controlPoints.filter((x) => {
          return x.id === selectedControlPointId;
        })[0];

        const route = routes.filter((x) => {
          return x.id === selectedRouteId;
        })[0];

        const inRoute = route.controlPoints.some((controlPoint) => {
          return controlPoint.id === selectedControlPointId;
        });

        const isLast = route.controlPoints.length > 0 && route.controlPoints[route.controlPoints.length - 1].id === selectedControlPointId;

        this.setState({
          route,
          controlPoint,
          inRoute,
          isLast,
        });
      }
    }
  }

  render() {
    const { controlPoint, route, inRoute, isLast } = this.state;

    if (controlPoint === null || route === null) {
      return null;
    }

    const acceptChange = route.dayOffTrips.length === 0 && route.workDayTrips.length === 0;

    if (!acceptChange) {
      return null;
    }

    return (
      <div className={styles.routeControlPointToolContainer}>
        <div> {controlPoint.title}</div>

        {inRoute ? (
          isLast ? (
            <div className={styles.routeControlPointBtnContainer} onClick={this.buttonClickHandle.bind(this)}>
              Удалить
            </div>
          ) : null
        ) : (
          <div className={styles.routeControlPointBtnContainer} onClick={this.buttonClickHandle.bind(this)}>
            Добавить
          </div>
        )}
      </div>
    );
  }
}

export default withRouteControlPoint(withRoutes(withControlPoints(RouteControlPointTools)));
